import { DataTableWidget as DataTable } from "@ecologi/react-components/src/DataTable/DataTableWidget";

export default function DataTableWidget({ data }) {
  const columnContentTypes: string[] = [];
  const headerData = data.table.header;

  const headings: string[] | undefined =
    headerData instanceof Array
      ? headerData.map((header) => {
          columnContentTypes.push("text");
          return header.c;
        })
      : undefined;

  const rows = data.table.body.map((row) => row.map((item) => item.c));

  return (
    <DataTable
      {...data}
      headings={headings}
      columnContentTypes={columnContentTypes}
      rows={rows}
      title={data.title}
    />
  );
}
